import {Localized} from "@fluent/react";
import WarningIcon from "@mui/icons-material/Warning";
import {Paper, Stack, Typography} from "@mui/material";
import React from "react";

function UnsupportedExerciseWarning() {
	return (
		<Paper
			component={Stack}
			direction="row"
			spacing={1}
			sx={{alignItems: "center", p: 3}}
		>
			<WarningIcon color="warning" />
			<Typography>
				<Localized id="unsupported-exercise-warning-text">
					Unsupported exercise type
				</Localized>
			</Typography>
		</Paper>
	);
}

export default UnsupportedExerciseWarning;
